import styled from 'styled-components';

export const StyleSummaryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.m};
`;

export const SummaryCardTitle = styled.div`
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const SummaryDataContainer = styled.div`
  display: flex;
  padding: 0 ${({ theme }) => theme.spacing.xs}
    ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.xs};
  align-items: center;
`;

export const SummaryInfosContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const SummaryInfosTextContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const SummaryInfosTitlesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xm};
`;

export const SummaryInfosTitle = styled.div`
  width: 100%;
`;

export const SummaryButtonBlockContainer = styled.div``;

export const SummaryButtonBlockColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m} 0;
`;

export const SummaryHeaderContainer = styled.div``;
